var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 176.22 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,0C58.74,0,117.48,0,176.22,0c-.63,9.08-1.25,18.17-1.88,27.25-1.6,22.97-3.21,45.95-4.83,68.92-1.8,25.57-3.64,51.13-5.41,76.7-.11,1.57-.61,2.35-2.19,2.87-21.45,7-42.88,14.07-64.3,21.15-2.93.97-5.82,2.07-8.72,3.11h-1.17c-.66-.26-1.3-.56-1.97-.79-23.09-7.62-46.19-15.24-69.28-22.86-4.18-1.38-4.09-1.39-4.39-5.8-.92-13.7-1.9-27.39-2.87-41.08-.98-13.89-1.99-27.78-2.97-41.66-.96-13.56-1.91-27.13-2.87-40.69C2.25,31.41,1.12,15.7,0,0ZM31.43,29.36c1.8,25.72,3.59,51.26,5.38,76.93h78.91c.07.32.16.51.15.68-.64,9.35-1.27,18.7-2,28.04-.05.58-.86,1.38-1.48,1.59-7.61,2.59-15.25,5.12-22.91,7.59-.79.26-1.81.28-2.6.02-7.71-2.49-15.4-5.08-23.1-7.6-1-.33-1.46-.78-1.47-1.9-.02-1.66-.27-3.31-.42-4.92h-23.21c0,.81-.04,1.51,0,2.21.46,6.56.99,13.11,1.37,19.67.08,1.36.56,1.86,1.78,2.27,14.96,4.96,29.89,9.99,44.86,14.93.9.3,2.06.28,2.96-.02,14.47-4.78,28.91-9.64,43.37-14.47q3.12-1.04,3.35-4.34c1.43-20.12,2.87-40.24,4.29-60.36.16-2.24.28-4.48.42-6.87H58.68c-.71-10.03-1.4-19.93-2.12-30.08h86.66c.55-7.92,1.09-15.6,1.64-23.36H31.43Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.a86ddc063c0b1e391bbdea32d4a89f20.svg";
export { ForwardRef as ReactComponent };